import { useContext, useMemo } from "react";
import { useTooltipLegacy, TooltipLegacyProps } from "./useTooltipLegacy";
import { TooltipLegacyContext } from "./useTooltipLegacyContext";
import { TooltipLegacyTrigger } from "./TooltipLegacyTrigger";
import { TooltipLegacyContent } from "./TooltipLegacyContent";
import { ThemeProviderContext } from "../../providers";

export function TooltipLegacyElement({
  children,
  ...options
}: TooltipLegacyProps) {
  // This can accept any props as options, e.g. `placement`,
  // or other positioning options.
  const tooltip = useTooltipLegacy(options);
  const { theme, mode } = useContext(ThemeProviderContext);

  const value = useMemo(
    () => ({ ...tooltip, theme, mode }),
    [mode, theme, tooltip],
  );
  return (
    <TooltipLegacyContext.Provider value={value}>
      {children}
    </TooltipLegacyContext.Provider>
  );
}

export const TooltipLegacy = Object.assign(TooltipLegacyElement, {
  Trigger: TooltipLegacyTrigger,
  Content: TooltipLegacyContent,
});
